export default "assets/MiniMoog_Main.png"